import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import { SEO } from '../components/seo'
import './fragments'
import ConfiguratorBuilder from '../components/features/configurator'
// We use kebab-case when referring to a panel in a JSON page file
// We use PascalCase for naming components

const wrapperProps = {
  data: PropTypes.shape({
    pagesJson: PropTypes.shape({
      configurator: PropTypes.shape({
        content: PropTypes.string,
        heading: PropTypes.string.isRequired,
        packages: PropTypes.arrayOf(
          PropTypes.shape({
            addToCartPath: PropTypes.string,
            amount: PropTypes.number,
            id: PropTypes.string,
            itemCode: PropTypes.string,
            itemDescription: PropTypes.string,
            packageId: PropTypes.number,
            product: PropTypes.string,
            productCategory: PropTypes.string,
            returnPath: PropTypes.string,
            source: PropTypes.string,
            title: PropTypes.string,
          })
        ),
        type: PropTypes.string.isRequired,
      }).isRequired,
      layoutProps: PropTypes.shape({
        removeNavigation: PropTypes.bool,
        showNewsletterSignup: PropTypes.bool,
      }),
      panels: PropTypes.arrayOf(PropTypes.shape({})),
      reseller: PropTypes.string,
      seo: PropTypes.shape({
        description: PropTypes.string,
        title: PropTypes.string,
      }).isRequired,
      slug: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

const ProductPageWrapper = ({ data }) => {
  const { seo: pageSEO, slug, layoutProps } = data.pagesJson

  const { title, description, imageUrl } = pageSEO
  const showNewsletterSignup = layoutProps?.showNewsletterSignup
  const hasNavigation = layoutProps?.removeNavigation

  return (
    <Layout
      hasNavigation={!hasNavigation}
      location={slug}
      showNewsletterSignup={showNewsletterSignup}
    >
      <SEO
        description={description}
        imageUrl={imageUrl}
        location={slug}
        title={title}
      />
      <ConfiguratorBuilder data={data} />
    </Layout>
  )
}

ProductPageWrapper.propTypes = wrapperProps

export const query = graphql`
  query ($slug: String!, $reseller: String) {
    pagesJson(slug: { eq: $slug }, reseller: { eq: $reseller }) {
      slug
      layoutProps {
        showNewsletterSignup
        removeNavigation
      }
      seo {
        title
        description
        imageUrl
      }
      componentName
      configurator {
        id
        heading
        type
        content
        addButtonContent
        packages {
          id
          clickHerePath
          addToCartPath
          amount
          itemCode
          itemDescription
          product
          productCategory
          productType
          packageId
          returnPath
          source
          title
          features
          costPerUser {
            suffix
            cad {
              sale
              regular
            }
            usd {
              sale
              regular
            }
            aud {
              sale
              regular
            }
            mxn {
              sale
              regular
            }
          }
          price {
            suffix
            itemCode
            cad {
              sale
              regular
            }
            usd {
              sale
              regular
            }
            aud {
              sale
              regular
            }
            mxn {
              sale
              regular
            }
          }
        }
      }
    }
  }
`
export default ProductPageWrapper
